module.exports = __webpack_public_path__ + "static/media/game2.99783bf7.png";